import DisplayHtml from '@/components/common/DisplayHtml';
import { useGetMenuFooterQuery } from '@/features/api/endpoints/LayoutEndpoints';
import { Box, Divider } from '@mantine/core';

const Footer = () => {
  const { data: footer } = useGetMenuFooterQuery();

  if (!footer || footer.status !== 'published') {
    return null;
  }

  return (
    <Box>
      {footer.zone1 && (
        <Box>
          <DisplayHtml html={footer.zone1} allowTargetBlank />
        </Box>
      )}
      {footer.zone1 && footer.zone2 && <Divider />}
      {footer.zone2 && (
        <Box>
          <DisplayHtml html={footer.zone2} allowTargetBlank />
        </Box>
      )}
    </Box>
  );
};

export default Footer;
